/* tslint:disable */
/* eslint-disable */
/**
 * Client
 * Placeholder description of the order & payment instruction service. Detailed description to be provided by Monavate team.
 *
 * The version of the OpenAPI document: $project.version
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BankPaymentFeeRequest } from '../models';
// @ts-ignore
import type { CardProductRequest } from '../models';
// @ts-ignore
import type { CardProductUpdateRequest } from '../models';
// @ts-ignore
import type { Client } from '../models';
// @ts-ignore
import type { ClientRequest } from '../models';
// @ts-ignore
import type { CompanyUpdateRequest } from '../models';
// @ts-ignore
import type { ConfigUpdateRequest } from '../models';
// @ts-ignore
import type { CreateUserRequest } from '../models';
// @ts-ignore
import type { CreateUserResponse } from '../models';
// @ts-ignore
import type { CreatedAccounts } from '../models';
// @ts-ignore
import type { IbansSetupResponse } from '../models';
// @ts-ignore
import type { NotFoundError } from '../models';
// @ts-ignore
import type { Representative } from '../models';
// @ts-ignore
import type { ValidationError } from '../models';
/**
 * OnboardingApi - axios parameter creator
 * @export
 */
export const OnboardingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add new card product to client\'s configuration.
         * @summary Add new card product to client\'s configuration.
         * @param {CardProductRequest} cardProductRequest 
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCardProduct: async (cardProductRequest: CardProductRequest, clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardProductRequest' is not null or undefined
            assertParamExists('addCardProduct', 'cardProductRequest', cardProductRequest)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('addCardProduct', 'clientId', clientId)
            const localVarPath = `/clients/{client-id}/config/card-products`
                .replace(`{${"client-id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates and configures a new Client.
         * @summary Create client
         * @param {ClientRequest} clientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClient: async (clientRequest: ClientRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientRequest' is not null or undefined
            assertParamExists('createClient', 'clientRequest', clientRequest)
            const localVarPath = `/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the details of a specified client.
         * @summary View client
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClient: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getClient', 'clientId', clientId)
            const localVarPath = `/clients/{client-id}`
                .replace(`{${"client-id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get information about configured iban accounts for a specified client.
         * @summary Get information about configured iban accounts for a specified client
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIbansSetup: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getIbansSetup', 'clientId', clientId)
            const localVarPath = `/clients/{client-id}/setup/ibans`
                .replace(`{${"client-id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves list of Clients.
         * @summary Get all clients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClients: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a customer for a specified client if not exists.
         * @summary Setup customer for a specified client
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupCustomer: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('setupCustomer', 'clientId', clientId)
            const localVarPath = `/clients/{client-id}/setup/customer`
                .replace(`{${"client-id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates two iban accounts for each enabled currency.
         * @summary Setup iban accounts for a specified client
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupIbans: async (clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('setupIbans', 'clientId', clientId)
            const localVarPath = `/clients/{client-id}/setup/ibans`
                .replace(`{${"client-id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a user for a specified client.
         * @summary Setup user for a specified client
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {CreateUserRequest} [createUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupUser: async (clientId: string, createUserRequest?: CreateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('setupUser', 'clientId', clientId)
            const localVarPath = `/clients/{client-id}/setup/initial-user`
                .replace(`{${"client-id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update bank payment fees for the specified client and currency
         * @summary Update bank payment fees for the specified client and currency
         * @param {BankPaymentFeeRequest} bankPaymentFeeRequest 
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {string} currency The 3-letters code of the currency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankPaymentFees: async (bankPaymentFeeRequest: BankPaymentFeeRequest, clientId: string, currency: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankPaymentFeeRequest' is not null or undefined
            assertParamExists('updateBankPaymentFees', 'bankPaymentFeeRequest', bankPaymentFeeRequest)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateBankPaymentFees', 'clientId', clientId)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('updateBankPaymentFees', 'currency', currency)
            const localVarPath = `/clients/{client-id}/config/currencies/{currency}/fees`
                .replace(`{${"client-id"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"currency"}}`, encodeURIComponent(String(currency)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankPaymentFeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update existing card product\'s configuration.
         * @summary Update existing card product\'s configuration.
         * @param {CardProductUpdateRequest} cardProductUpdateRequest 
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {string} productType product type code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardProduct: async (cardProductUpdateRequest: CardProductUpdateRequest, clientId: string, productType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cardProductUpdateRequest' is not null or undefined
            assertParamExists('updateCardProduct', 'cardProductUpdateRequest', cardProductUpdateRequest)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateCardProduct', 'clientId', clientId)
            // verify required parameter 'productType' is not null or undefined
            assertParamExists('updateCardProduct', 'productType', productType)
            const localVarPath = `/clients/{client-id}/config/card-products/{product-type}`
                .replace(`{${"client-id"}}`, encodeURIComponent(String(clientId)))
                .replace(`{${"product-type"}}`, encodeURIComponent(String(productType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cardProductUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates company details of a specified client.
         * @summary Update client\'s company details
         * @param {CompanyUpdateRequest} companyUpdateRequest 
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientCompanyDetails: async (companyUpdateRequest: CompanyUpdateRequest, clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyUpdateRequest' is not null or undefined
            assertParamExists('updateClientCompanyDetails', 'companyUpdateRequest', companyUpdateRequest)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateClientCompanyDetails', 'clientId', clientId)
            const localVarPath = `/clients/{client-id}/company`
                .replace(`{${"client-id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates company representative details of a specified client.
         * @summary Update the client\'s company representative details
         * @param {Representative} representative 
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientCompanyRepresentativeDetails: async (representative: Representative, clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'representative' is not null or undefined
            assertParamExists('updateClientCompanyRepresentativeDetails', 'representative', representative)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateClientCompanyRepresentativeDetails', 'clientId', clientId)
            const localVarPath = `/clients/{client-id}/company/representative`
                .replace(`{${"client-id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(representative, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update client\'s configuration
         * @summary Update client\'s configuration
         * @param {ConfigUpdateRequest} configUpdateRequest 
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfig: async (configUpdateRequest: ConfigUpdateRequest, clientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configUpdateRequest' is not null or undefined
            assertParamExists('updateConfig', 'configUpdateRequest', configUpdateRequest)
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateConfig', 'clientId', clientId)
            const localVarPath = `/clients/{client-id}/config/general`
                .replace(`{${"client-id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingApi - functional programming interface
 * @export
 */
export const OnboardingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingApiAxiosParamCreator(configuration)
    return {
        /**
         * Add new card product to client\'s configuration.
         * @summary Add new card product to client\'s configuration.
         * @param {CardProductRequest} cardProductRequest 
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCardProduct(cardProductRequest: CardProductRequest, clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCardProduct(cardProductRequest, clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.addCardProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates and configures a new Client.
         * @summary Create client
         * @param {ClientRequest} clientRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClient(clientRequest: ClientRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClient(clientRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.createClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the details of a specified client.
         * @summary View client
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClient(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClient(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.getClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get information about configured iban accounts for a specified client.
         * @summary Get information about configured iban accounts for a specified client
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIbansSetup(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbansSetupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIbansSetup(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.getIbansSetup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves list of Clients.
         * @summary Get all clients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listClients(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Client>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listClients(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.listClients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a customer for a specified client if not exists.
         * @summary Setup customer for a specified client
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setupCustomer(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setupCustomer(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.setupCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates two iban accounts for each enabled currency.
         * @summary Setup iban accounts for a specified client
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setupIbans(clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedAccounts>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setupIbans(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.setupIbans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a user for a specified client.
         * @summary Setup user for a specified client
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {CreateUserRequest} [createUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setupUser(clientId: string, createUserRequest?: CreateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setupUser(clientId, createUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.setupUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update bank payment fees for the specified client and currency
         * @summary Update bank payment fees for the specified client and currency
         * @param {BankPaymentFeeRequest} bankPaymentFeeRequest 
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {string} currency The 3-letters code of the currency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBankPaymentFees(bankPaymentFeeRequest: BankPaymentFeeRequest, clientId: string, currency: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBankPaymentFees(bankPaymentFeeRequest, clientId, currency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.updateBankPaymentFees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update existing card product\'s configuration.
         * @summary Update existing card product\'s configuration.
         * @param {CardProductUpdateRequest} cardProductUpdateRequest 
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {string} productType product type code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCardProduct(cardProductUpdateRequest: CardProductUpdateRequest, clientId: string, productType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCardProduct(cardProductUpdateRequest, clientId, productType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.updateCardProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates company details of a specified client.
         * @summary Update client\'s company details
         * @param {CompanyUpdateRequest} companyUpdateRequest 
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientCompanyDetails(companyUpdateRequest: CompanyUpdateRequest, clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientCompanyDetails(companyUpdateRequest, clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.updateClientCompanyDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates company representative details of a specified client.
         * @summary Update the client\'s company representative details
         * @param {Representative} representative 
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientCompanyRepresentativeDetails(representative: Representative, clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientCompanyRepresentativeDetails(representative, clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.updateClientCompanyRepresentativeDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update client\'s configuration
         * @summary Update client\'s configuration
         * @param {ConfigUpdateRequest} configUpdateRequest 
         * @param {string} clientId The unique ID of a client that needs to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConfig(configUpdateRequest: ConfigUpdateRequest, clientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConfig(configUpdateRequest, clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.updateConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnboardingApi - factory interface
 * @export
 */
export const OnboardingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingApiFp(configuration)
    return {
        /**
         * Add new card product to client\'s configuration.
         * @summary Add new card product to client\'s configuration.
         * @param {OnboardingApiAddCardProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCardProduct(requestParameters: OnboardingApiAddCardProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<Client> {
            return localVarFp.addCardProduct(requestParameters.cardProductRequest, requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates and configures a new Client.
         * @summary Create client
         * @param {OnboardingApiCreateClientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClient(requestParameters: OnboardingApiCreateClientRequest, options?: RawAxiosRequestConfig): AxiosPromise<Client> {
            return localVarFp.createClient(requestParameters.clientRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the details of a specified client.
         * @summary View client
         * @param {OnboardingApiGetClientRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClient(requestParameters: OnboardingApiGetClientRequest, options?: RawAxiosRequestConfig): AxiosPromise<Client> {
            return localVarFp.getClient(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get information about configured iban accounts for a specified client.
         * @summary Get information about configured iban accounts for a specified client
         * @param {OnboardingApiGetIbansSetupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIbansSetup(requestParameters: OnboardingApiGetIbansSetupRequest, options?: RawAxiosRequestConfig): AxiosPromise<IbansSetupResponse> {
            return localVarFp.getIbansSetup(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves list of Clients.
         * @summary Get all clients
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClients(options?: RawAxiosRequestConfig): AxiosPromise<Array<Client>> {
            return localVarFp.listClients(options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a customer for a specified client if not exists.
         * @summary Setup customer for a specified client
         * @param {OnboardingApiSetupCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupCustomer(requestParameters: OnboardingApiSetupCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<Client> {
            return localVarFp.setupCustomer(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates two iban accounts for each enabled currency.
         * @summary Setup iban accounts for a specified client
         * @param {OnboardingApiSetupIbansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupIbans(requestParameters: OnboardingApiSetupIbansRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreatedAccounts> {
            return localVarFp.setupIbans(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a user for a specified client.
         * @summary Setup user for a specified client
         * @param {OnboardingApiSetupUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setupUser(requestParameters: OnboardingApiSetupUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserResponse> {
            return localVarFp.setupUser(requestParameters.clientId, requestParameters.createUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update bank payment fees for the specified client and currency
         * @summary Update bank payment fees for the specified client and currency
         * @param {OnboardingApiUpdateBankPaymentFeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankPaymentFees(requestParameters: OnboardingApiUpdateBankPaymentFeesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Client> {
            return localVarFp.updateBankPaymentFees(requestParameters.bankPaymentFeeRequest, requestParameters.clientId, requestParameters.currency, options).then((request) => request(axios, basePath));
        },
        /**
         * Update existing card product\'s configuration.
         * @summary Update existing card product\'s configuration.
         * @param {OnboardingApiUpdateCardProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCardProduct(requestParameters: OnboardingApiUpdateCardProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<Client> {
            return localVarFp.updateCardProduct(requestParameters.cardProductUpdateRequest, requestParameters.clientId, requestParameters.productType, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates company details of a specified client.
         * @summary Update client\'s company details
         * @param {OnboardingApiUpdateClientCompanyDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientCompanyDetails(requestParameters: OnboardingApiUpdateClientCompanyDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Client> {
            return localVarFp.updateClientCompanyDetails(requestParameters.companyUpdateRequest, requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates company representative details of a specified client.
         * @summary Update the client\'s company representative details
         * @param {OnboardingApiUpdateClientCompanyRepresentativeDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientCompanyRepresentativeDetails(requestParameters: OnboardingApiUpdateClientCompanyRepresentativeDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Client> {
            return localVarFp.updateClientCompanyRepresentativeDetails(requestParameters.representative, requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update client\'s configuration
         * @summary Update client\'s configuration
         * @param {OnboardingApiUpdateConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfig(requestParameters: OnboardingApiUpdateConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<Client> {
            return localVarFp.updateConfig(requestParameters.configUpdateRequest, requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addCardProduct operation in OnboardingApi.
 * @export
 * @interface OnboardingApiAddCardProductRequest
 */
export interface OnboardingApiAddCardProductRequest {
    /**
     * 
     * @type {CardProductRequest}
     * @memberof OnboardingApiAddCardProduct
     */
    readonly cardProductRequest: CardProductRequest

    /**
     * The unique ID of a client that needs to be retrieved.
     * @type {string}
     * @memberof OnboardingApiAddCardProduct
     */
    readonly clientId: string
}

/**
 * Request parameters for createClient operation in OnboardingApi.
 * @export
 * @interface OnboardingApiCreateClientRequest
 */
export interface OnboardingApiCreateClientRequest {
    /**
     * 
     * @type {ClientRequest}
     * @memberof OnboardingApiCreateClient
     */
    readonly clientRequest: ClientRequest
}

/**
 * Request parameters for getClient operation in OnboardingApi.
 * @export
 * @interface OnboardingApiGetClientRequest
 */
export interface OnboardingApiGetClientRequest {
    /**
     * The unique ID of a client that needs to be retrieved.
     * @type {string}
     * @memberof OnboardingApiGetClient
     */
    readonly clientId: string
}

/**
 * Request parameters for getIbansSetup operation in OnboardingApi.
 * @export
 * @interface OnboardingApiGetIbansSetupRequest
 */
export interface OnboardingApiGetIbansSetupRequest {
    /**
     * The unique ID of a client that needs to be retrieved.
     * @type {string}
     * @memberof OnboardingApiGetIbansSetup
     */
    readonly clientId: string
}

/**
 * Request parameters for setupCustomer operation in OnboardingApi.
 * @export
 * @interface OnboardingApiSetupCustomerRequest
 */
export interface OnboardingApiSetupCustomerRequest {
    /**
     * The unique ID of a client that needs to be retrieved.
     * @type {string}
     * @memberof OnboardingApiSetupCustomer
     */
    readonly clientId: string
}

/**
 * Request parameters for setupIbans operation in OnboardingApi.
 * @export
 * @interface OnboardingApiSetupIbansRequest
 */
export interface OnboardingApiSetupIbansRequest {
    /**
     * The unique ID of a client that needs to be retrieved.
     * @type {string}
     * @memberof OnboardingApiSetupIbans
     */
    readonly clientId: string
}

/**
 * Request parameters for setupUser operation in OnboardingApi.
 * @export
 * @interface OnboardingApiSetupUserRequest
 */
export interface OnboardingApiSetupUserRequest {
    /**
     * The unique ID of a client that needs to be retrieved.
     * @type {string}
     * @memberof OnboardingApiSetupUser
     */
    readonly clientId: string

    /**
     * 
     * @type {CreateUserRequest}
     * @memberof OnboardingApiSetupUser
     */
    readonly createUserRequest?: CreateUserRequest
}

/**
 * Request parameters for updateBankPaymentFees operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUpdateBankPaymentFeesRequest
 */
export interface OnboardingApiUpdateBankPaymentFeesRequest {
    /**
     * 
     * @type {BankPaymentFeeRequest}
     * @memberof OnboardingApiUpdateBankPaymentFees
     */
    readonly bankPaymentFeeRequest: BankPaymentFeeRequest

    /**
     * The unique ID of a client that needs to be retrieved.
     * @type {string}
     * @memberof OnboardingApiUpdateBankPaymentFees
     */
    readonly clientId: string

    /**
     * The 3-letters code of the currency
     * @type {string}
     * @memberof OnboardingApiUpdateBankPaymentFees
     */
    readonly currency: string
}

/**
 * Request parameters for updateCardProduct operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUpdateCardProductRequest
 */
export interface OnboardingApiUpdateCardProductRequest {
    /**
     * 
     * @type {CardProductUpdateRequest}
     * @memberof OnboardingApiUpdateCardProduct
     */
    readonly cardProductUpdateRequest: CardProductUpdateRequest

    /**
     * The unique ID of a client that needs to be retrieved.
     * @type {string}
     * @memberof OnboardingApiUpdateCardProduct
     */
    readonly clientId: string

    /**
     * product type code
     * @type {string}
     * @memberof OnboardingApiUpdateCardProduct
     */
    readonly productType: string
}

/**
 * Request parameters for updateClientCompanyDetails operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUpdateClientCompanyDetailsRequest
 */
export interface OnboardingApiUpdateClientCompanyDetailsRequest {
    /**
     * 
     * @type {CompanyUpdateRequest}
     * @memberof OnboardingApiUpdateClientCompanyDetails
     */
    readonly companyUpdateRequest: CompanyUpdateRequest

    /**
     * The unique ID of a client that needs to be retrieved.
     * @type {string}
     * @memberof OnboardingApiUpdateClientCompanyDetails
     */
    readonly clientId: string
}

/**
 * Request parameters for updateClientCompanyRepresentativeDetails operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUpdateClientCompanyRepresentativeDetailsRequest
 */
export interface OnboardingApiUpdateClientCompanyRepresentativeDetailsRequest {
    /**
     * 
     * @type {Representative}
     * @memberof OnboardingApiUpdateClientCompanyRepresentativeDetails
     */
    readonly representative: Representative

    /**
     * The unique ID of a client that needs to be retrieved.
     * @type {string}
     * @memberof OnboardingApiUpdateClientCompanyRepresentativeDetails
     */
    readonly clientId: string
}

/**
 * Request parameters for updateConfig operation in OnboardingApi.
 * @export
 * @interface OnboardingApiUpdateConfigRequest
 */
export interface OnboardingApiUpdateConfigRequest {
    /**
     * 
     * @type {ConfigUpdateRequest}
     * @memberof OnboardingApiUpdateConfig
     */
    readonly configUpdateRequest: ConfigUpdateRequest

    /**
     * The unique ID of a client that needs to be retrieved.
     * @type {string}
     * @memberof OnboardingApiUpdateConfig
     */
    readonly clientId: string
}

/**
 * OnboardingApi - object-oriented interface
 * @export
 * @class OnboardingApi
 * @extends {BaseAPI}
 */
export class OnboardingApi extends BaseAPI {
    /**
     * Add new card product to client\'s configuration.
     * @summary Add new card product to client\'s configuration.
     * @param {OnboardingApiAddCardProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public addCardProduct(requestParameters: OnboardingApiAddCardProductRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).addCardProduct(requestParameters.cardProductRequest, requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates and configures a new Client.
     * @summary Create client
     * @param {OnboardingApiCreateClientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public createClient(requestParameters: OnboardingApiCreateClientRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).createClient(requestParameters.clientRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the details of a specified client.
     * @summary View client
     * @param {OnboardingApiGetClientRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public getClient(requestParameters: OnboardingApiGetClientRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).getClient(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get information about configured iban accounts for a specified client.
     * @summary Get information about configured iban accounts for a specified client
     * @param {OnboardingApiGetIbansSetupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public getIbansSetup(requestParameters: OnboardingApiGetIbansSetupRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).getIbansSetup(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves list of Clients.
     * @summary Get all clients
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public listClients(options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).listClients(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a customer for a specified client if not exists.
     * @summary Setup customer for a specified client
     * @param {OnboardingApiSetupCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public setupCustomer(requestParameters: OnboardingApiSetupCustomerRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).setupCustomer(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates two iban accounts for each enabled currency.
     * @summary Setup iban accounts for a specified client
     * @param {OnboardingApiSetupIbansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public setupIbans(requestParameters: OnboardingApiSetupIbansRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).setupIbans(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a user for a specified client.
     * @summary Setup user for a specified client
     * @param {OnboardingApiSetupUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public setupUser(requestParameters: OnboardingApiSetupUserRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).setupUser(requestParameters.clientId, requestParameters.createUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update bank payment fees for the specified client and currency
     * @summary Update bank payment fees for the specified client and currency
     * @param {OnboardingApiUpdateBankPaymentFeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public updateBankPaymentFees(requestParameters: OnboardingApiUpdateBankPaymentFeesRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).updateBankPaymentFees(requestParameters.bankPaymentFeeRequest, requestParameters.clientId, requestParameters.currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update existing card product\'s configuration.
     * @summary Update existing card product\'s configuration.
     * @param {OnboardingApiUpdateCardProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public updateCardProduct(requestParameters: OnboardingApiUpdateCardProductRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).updateCardProduct(requestParameters.cardProductUpdateRequest, requestParameters.clientId, requestParameters.productType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates company details of a specified client.
     * @summary Update client\'s company details
     * @param {OnboardingApiUpdateClientCompanyDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public updateClientCompanyDetails(requestParameters: OnboardingApiUpdateClientCompanyDetailsRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).updateClientCompanyDetails(requestParameters.companyUpdateRequest, requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates company representative details of a specified client.
     * @summary Update the client\'s company representative details
     * @param {OnboardingApiUpdateClientCompanyRepresentativeDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public updateClientCompanyRepresentativeDetails(requestParameters: OnboardingApiUpdateClientCompanyRepresentativeDetailsRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).updateClientCompanyRepresentativeDetails(requestParameters.representative, requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update client\'s configuration
     * @summary Update client\'s configuration
     * @param {OnboardingApiUpdateConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public updateConfig(requestParameters: OnboardingApiUpdateConfigRequest, options?: RawAxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).updateConfig(requestParameters.configUpdateRequest, requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }
}

